var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDonwloadDash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.04167 5.09374V0.666656H1.53125C1.09831 0.666656 0.75 1.01496 0.75 1.44791V16.5521C0.75 16.985 1.09831 17.3333 1.53125 17.3333H12.4688C12.9017 17.3333 13.25 16.985 13.25 16.5521V5.87499H8.82292C8.39323 5.87499 8.04167 5.52343 8.04167 5.09374ZM10.5303 11.9739L7.3916 15.0892C7.17513 15.3044 6.82552 15.3044 6.60905 15.0892L3.47038 11.9739C3.13997 11.6461 3.37174 11.0833 3.83659 11.0833H5.95833V8.47916C5.95833 8.1914 6.19141 7.95832 6.47917 7.95832H7.52083C7.80859 7.95832 8.04167 8.1914 8.04167 8.47916V11.0833H10.1634C10.6283 11.0833 10.86 11.6461 10.5303 11.9739ZM13.0221 4.08463L9.83529 0.894521C9.6888 0.748037 9.49023 0.666656 9.2819 0.666656H9.08333V4.83332H13.25V4.63476C13.25 4.42968 13.1686 4.23111 13.0221 4.08463Z",
    fill: "#3E72DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonwloadDash);
export default __webpack_public_path__ + "static/media/DonwloadDash.d54c6d39c26947c53f7c6e5f6d8dbd86.svg";
export { ForwardRef as ReactComponent };